import { useState } from "react";

const FAQAndPricing = () => {
  const [activeAccordion, setActiveAccordion] = useState("faq-1");

  const pricingPlans = [
    {
      id: 1,
      price: 199,
      name: "Basic Plan",
      description: "Add more than 20 Cars, Get Booked around 200 Customers",
      isActive: false,
    },
    {
      id: 2,
      price: 399,
      name: "Enterprise",
      description: "Add more than 20 Cars, Get Booked around 200 Customers",
      isActive: true,
    },
    {
      id: 3,
      price: 899,
      name: "Premium",
      description: "Add more than 50 Cars, Get Booked around 500 Customers",
      isActive: false,
    },
  ];

  const faqs = [
    {
      id: "faq-1",
      question: "How do I book a car?",
      answer:
        "Simply enter your location, pick-up and drop-off dates, and search through the available options. Choose the car that fits your needs, and follow the steps to complete the booking.",
    },
    {
      id: "faq-2",
      question: "Are the tours customizable?",
      answer:
        "We offer a wide range of tours, including cultural, adventure, luxury, and customized itineraries.",
    },
    {
      id: "faq-3",
      question: "What safety measures do you follow?",
      answer:
        "We offer a wide range of tours, including cultural, adventure, luxury, and customized itineraries.",
    },
    {
      id: "faq-4",
      question: "How far in advance should I book?",
      answer:
        "We offer a wide range of tours, including cultural, adventure, luxury, and customized itineraries.",
    },
    {
      id: "faq-5",
      question: "What is your cancellation policy?",
      answer:
        "We offer a wide range of tours, including cultural, adventure, luxury, and customized itineraries.",
    },
  ];

  const toggleAccordion = (id) => {
    setActiveAccordion(activeAccordion === id ? null : id);
  };

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Outfit:wght@400;500;600;700;800&display=swap');

        * { box-sizing: border-box; margin: 0; padding: 0; }

        .faq-pricing-section {
          font-family: ;
          background-color: #0d1421;
          width: 100%;
          min-height: 64vh;
          position: relative;
          overflow: hidden;
          padding: 60px 40px 80px;
        }

        /* Top white wave curve */
        .top-wave {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 60px;
          overflow: hidden;
          pointer-events: none;
        }
        .top-wave svg {
          width: 100%;
          height: 100%;
        }

        /* Decorative thin curved line on left side */
        .deco-line-left {
          position: absolute;
          left: 60px;
          top: 30%;
          width: 2px;
          height: 300px;
          pointer-events: none;
          opacity: 0.3;
        }

        .main-grid {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 60px;
          max-width: 1300px;
          margin: 0 auto;
          position: relative;
          z-index: 2;
          padding-top: 30px;
        }

        /* ============ PRICING CARDS ============ */
        .pricing-col {
          display: flex;
          flex-direction: column;
          gap: 0px;
          position: relative;
        }

        .plan-card {
          border-radius: 16px;
          padding: 28px 30px;
          position: relative;
          margin-bottom: 4px;
        }
        .plan-card.white-card {
          background: #ffffff;
          box-shadow: 0 4px 24px rgba(0,0,0,0.18);
        }
        .plan-card.red-card {
          background: #d63b2f;
          box-shadow: 0 4px 24px rgba(214,59,47,0.35);
        }

        /* Diagonal connector lines between cards */
        .card-connector {
          display: flex;
          justify-content: flex-end;
          padding-right: 20px;
          height: 20px;
          position: relative;
        }
        .card-connector::before {
          content: '';
          position: absolute;
          right: 40px;
          top: 0;
          width: 60px;
          height: 100%;
          border-right: 1.5px solid rgba(255,255,255,0.2);
          transform: skewX(-25deg);
        }
        .card-connector::after {
          content: '';
          position: absolute;
          right: 65px;
          top: 0;
          width: 60px;
          height: 100%;
          border-right: 1.5px solid rgba(255,255,255,0.15);
          transform: skewX(-25deg);
        }

        .card-top-row {
          display: flex;
          align-items: flex-start;
          justify-content: space-between;
          margin-bottom: 10px;
        }

        .price-tag {
          font-size: 44px;
          font-weight: 800;
          line-height: 1;
        }
        .white-card .price-tag {
          color: #d63b2f;
        }
        .red-card .price-tag {
          color: #ffffff;
        }

        .price-per {
          font-size: 14px;
          font-weight: 400;
          margin-left: 4px;
        }
        .white-card .price-per {
          color: #555;
        }
        .red-card .price-per {
          color: rgba(255,255,255,0.85);
        }

        .buy-btn {
          border: none;
          cursor: pointer;
          font-family: 'Outfit', sans-serif;
          font-size: 14px;
          font-weight: 600;
          padding: 10px 26px;
          border-radius: 50px;
          transition: all 0.2s ease;
        }
        .white-card .buy-btn {
          background: #1a2235;
          color: #ffffff;
        }
        .white-card .buy-btn:hover {
          background: #263048;
        }
        .red-card .buy-btn {
          background: #ffffff;
          color: #1a2235;
        }
        .red-card .buy-btn:hover {
          background: #f0f0f0;
        }

        .plan-name {
          font-size: 20px;
          font-weight: 700;
          margin-bottom: 6px;
        }
        .white-card .plan-name {
          color: #1a2235;
        }
        .red-card .plan-name {
          color: #ffffff;
        }

        .plan-desc {
          font-size: 14px;
          font-weight: 400;
          line-height: 1.5;
        }
        .white-card .plan-desc {
          color: #666;
        }
        .red-card .plan-desc {
          color: rgba(255,255,255,0.85);
        }

        /* ============ RIGHT COLUMN ============ */
        .right-col {
          display: flex;
          flex-direction: column;
        }

        /* Small red circle bullet */
        // .red-dot {
        //   width: 14px;
        //   height: 14px;
        //   border-radius: 50%;
        //   background: #8b1a1a;
        //   margin-bottom: 18px;
        //   flex-shrink: 0;
        // }

        .section-heading {
          font-size: 36px;
          font-weight: 800;
          color: #ffffff;
          line-height: 1.25;
          margin-bottom: 12px;
        }

        .section-subtext {
          font-size: 15px;
          color: rgba(255,255,255,0.55);
          margin-bottom: 32px;
          font-weight: 400;
        }

        /* ============ FAQ ============ */
        .faq-list {
          display: flex;
          flex-direction: column;
          gap: 0;
        }

        .faq-item {
          border-bottom: 1px solid rgba(255,255,255,0.1);
        }
        .faq-item:first-child {
          border-top: 1px solid rgba(255,255,255,0.1);
        }

        .faq-trigger {
          width: 100%;
          background: transparent;
          border: none;
          cursor: pointer;
          display: flex;
          align-items: center;
          gap: 16px;
          padding: 18px 0;
          text-align: left;
          font-family: 'Outfit', sans-serif;
        }

        /* Icon: circle with + or − */
        .faq-icon {
          width: 28px;
          height: 28px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
          font-size: 18px;
          font-weight: 700;
          line-height: 1;
          transition: all 0.25s ease;
        }
        .faq-icon.closed {
          background: #1e2d45;
          color: #ffffff;
          border: 2px solid rgba(255,255,255,0.15);
        }
        .faq-icon.open {
          background: #d63b2f;
          color: #ffffff;
          border: 2px solid #d63b2f;
        }

        .faq-question {
          font-size: 16px;
          font-weight: 600;
          color: #ffffff;
          flex: 1;
        }

        /* Answer panel */
        .faq-answer-wrap {
          overflow: hidden;
          max-height: 0;
          transition: max-height 0.35s ease, opacity 0.3s ease;
          opacity: 0;
        }
        .faq-answer-wrap.open {
          max-height: 200px;
          opacity: 1;
        }

        .faq-answer-inner {
          padding: 0 0 18px 44px;
          display: flex;
          gap: 0;
        }

        /* Left red bar */
        .red-bar {
          width: 3px;
          min-height: 100%;
          background: #d63b2f;
          border-radius: 4px;
          flex-shrink: 0;
          margin-right: 14px;
          align-self: stretch;
        }

        .faq-answer-text {
          font-size: 14px;
          color: rgba(255,255,255,0.7);
          line-height: 1.65;
          font-weight: 400;
        }

        @media (max-width: 900px) {
          .main-grid {
            grid-template-columns: 1fr;
            gap: 40px;
          }
          .faq-pricing-section {
            padding: 50px 20px 60px;
          }
          .section-heading {
            font-size: 28px;
          }
        }
      `}</style>

      <section className="faq-pricing-section">
        {/* Top white wave */}
        <div className="top-wave">
          <svg viewBox="0 0 1440 60" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M0,0 C360,80 1080,-20 1440,30 L1440,0 Z"
              fill="#f0f4f8"
              fillOpacity="0.95"
            />
          </svg>
        </div>

        <div className="main-grid">
          {/* LEFT — Pricing Plans */}
          <div className="pricing-col">
            {pricingPlans.map((plan, index) => (
              <div key={plan.id}>
                <div className={`plan-card ${plan.isActive ? "red-card" : "white-card"}`}>
                  <div className="card-top-row">
                    <div>
                      <span className="price-tag">
                        ${plan.price}
                        <span className="price-per"> / Month</span>
                      </span>
                    </div>
                    <button className="buy-btn">Buy Now</button>
                  </div>
                  <div className="plan-name">{plan.name}</div>
                  <div className="plan-desc">{plan.description}</div>
                </div>
                {/* Diagonal connector between cards */}
                {index < pricingPlans.length - 1 && (
                  <div className="card-connector" />
                )}
              </div>
            ))}
          </div>

          {/* RIGHT — Heading + FAQ */}
          <div className="right-col">
            {/* Small maroon dot */}
            <div className="red-dot" />

            <h2 className="section-heading">
              Start Adding Cars With Our Exclusive &amp; Updated Pricing Plans only for you
            </h2>
            <p className="section-subtext">
              Ask a Question To get Your Answers from Our DreamsTour Management
            </p>

            {/* FAQ */}
            <div className="faq-list">
              {faqs.map((faq) => {
                const isOpen = activeAccordion === faq.id;
                return (
                  <div className="faq-item" key={faq.id}>
                    <button
                      className="faq-trigger"
                      onClick={() => toggleAccordion(faq.id)}
                      aria-expanded={isOpen}
                    >
                      <span className={`faq-icon ${isOpen ? "open" : "closed"}`}>
                        {isOpen ? "−" : "+"}
                      </span>
                      <span className="faq-question">{faq.question}</span>
                    </button>

                    <div className={`faq-answer-wrap ${isOpen ? "open" : ""}`}>
                      <div className="faq-answer-inner">
                        <div className="red-bar" />
                        <p className="faq-answer-text">{faq.answer}</p>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default FAQAndPricing;